<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.assignedQueries}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="batch.batchName | safeHtml"></span>
	</h5>
</div>
<div class="dx-properties dx-table-entries modal-body">
	<div style="max-height: 600px; padding-left: 15px; overflow-y: auto; overflow-x: hidden">
	
		<div *ngIf="gridData.length == 0" style="margin-top: 10px;">
			<i>{{LOCALIZATION.resultsEmpty}}</i>
		</div>	

		<!-- Query Grid -->
		<div style="overflow-x:auto; overflow-y:hidden;">
		      <ag-grid-angular #kvGrid
		        style="width: 100%; height: 350px;"
		        [rowData]="gridData"
		        [columnDefs]="columns"
		        [defaultColDef]="defaultColDef"
		        pagination={true}
		        [paginationPageSize]="pagination.elementsPerPage"
		        [paginationPageSizeSelector]="pagination.elementsPerPageSizes"
		      />
		</div>

		<div id="nerList" *ngIf="ner.length > 0" style="margin-top: 15px;">
			<div class="list-header">NER Queries</div>
			<div class="ner-list">
				<div *ngFor="let n of ner; index as i;"
				     [ngClass]="{ 'dx-stripe': i % 2 === 0 }" 
				     class="well-sm">
				  <span class="truncate">{{ n.id }}</span>
				</div>
			</div>
		</div>		 
	</div>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>
